import { gql } from "@apollo/client";export default gql`mutation updateChapter(
    $object: group_set_input = {}
    $id: Int!
) {
    updateChapter: update_group_by_pk(
        pk_columns: { id: $id }
        _set: $object
    ) {
        id
        description
        cover
        other
        title
        type
    }
}
`;
